module.exports = __webpack_public_path__ + "img/SES_140250014.5fd4458c.jpg";